import {Session} from 'com/gongxigames/math/core/game/session/Session';
import {ResponseFilter} from 'com/gongxigames/math/core/client/ResponseFilter';
import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {consoleLogger} from '@gongxigames/framework/core';
import {AbstractFilter} from '@gongxigames/framework/slot/services/logic/mathfilters/AbstractFilter';

export class ArrayFilter implements ResponseFilter<Session> {
    public static readonly MAX_COUNT: number = 1000000;

    protected filters: ResponseFilter<Session>[];
    protected counter: number;

    constructor() {
        this.filters = [];
        this.counter = 0;
    }

    public isEmpty(): boolean {
        return this.filters.length === 0;
    }

    public addFilter(filter: ResponseFilter<Session>): void {
        this.filters.push(filter);
    }

    public removeFilter(filterID: number): void {
        this.filters.splice(filterID, 1);
    }

    public removeFilterByName(filterName: string): void {
        const filterID = (this.filters as AbstractFilter[]).findIndex(filter => filter.name === filterName);

        if (filterID > -1) {
            this.removeFilter(filterID);
        }
    }

    public removeFilters(): void {
        this.filters.length = 0;
    }

    public filter(response: Message, session: Session): boolean {
        if (++this.counter >= ArrayFilter.MAX_COUNT) {
            this.counter = 0;
            consoleLogger.log('[filter systemComponents] max count - ' + ArrayFilter.MAX_COUNT + ' achieved, could not find combination');
            this.printCurrentFilters();

            return true;
        }

        if (this.counter % 100000 === 0) {
            consoleLogger.log(this.counter);
        }

        for (const f of this.filters) {
            if (!f.filter(response, session)) {
                return false;
            }
        }

        consoleLogger.log('[filter systemComponents] ' + this.counter
            + (this.counter > 1 ? ' attempts were' : ' attempt was')
            + ' made to achieve the goal');
        this.printCurrentFilters();

        this.counter = 0;

        return true;
    }

    private printCurrentFilters(): void {
        const filters = this.filters.filter(filter => filter instanceof AbstractFilter) as AbstractFilter[];

        if (filters.length) {
            consoleLogger.log('filters: ' + filters
                .map(w => w.name)
                .join(', ')
            );
        }
    }
}
